import { render, staticRenderFns } from "./ListConvenio.vue?vue&type=template&id=b85aef76"
import script from "./ListConvenio.vue?vue&type=script&lang=js"
export * from "./ListConvenio.vue?vue&type=script&lang=js"
import style0 from "./ListConvenio.vue?vue&type=style&index=0&id=b85aef76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports